<template>
    <LayoutSub className="pb-0 foreigner">
        <SubpageTitleContainer :title="`이지택스리펀드(EasyTaxRefund)`"
            :subText="`외국인 관광객이 국내 매장에서 구입한 상품에 포함되어 있는 부가가치세 및 개별소비세를 출국 전 환급해주는 서비스로 <br />가맹점에서는 기존에 사용하던 이지체크 단말기를 통해 서비스를 사용할 수 있습니다.`">
            <RedLineButton :type="`outbound`" :text="`거래내역 조회`"
                href="https://www.easytaxrefund.co.kr/KOR/tourist/CSTradeInfoAction.do" />
            <RedLineButton :type="`inbound`" :text="`자주하는 질문`" to="/cs/faq" />
        </SubpageTitleContainer>
        <SubSection class="pt-0">
            <LineBox title="스마트한 4 in 1 단말기로 공간 활용을 용이하게" iconSrc="ic_4in1.png">
                <div class="box">신용카드 결제 서비스</div>
                <div class="box active">택스리펀드 서비스</div>
                <div class="box">자국통화(DCC) 서비스</div>
                <div class="box">해외 간편결제 서비스</div>
            </LineBox>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">특징</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid src="ic_sub3_1.png" title="타 매장과의 차별화"
                    content="외국인 관광객 대상 상품 판매를 통한 매출 증가와 별도의 프로모션 없이 할인과 유사한 효과를 낼 수 있습니다." />
                <TableRow_2grid src="ic_sub3_2.png" title="추가 구매 유인 효과"
                    content="환급 대상 금액(15,000 이상)에 도달하기 위한 추가 구매 및 환급을 통한 재구매 유도가 가능합니다." />
                <TableRow_2grid src="ic_sub3_3.png" title="연동 개발 지원"
                    content="POS, 회계 프로그램(ERP) 등 가맹점 특성에 맞게 서비스를 사용할 수 있도록 연동 개발을 지원합니다." />
            </div>
        </SubSection>
        <SubSection>
            <SubTitle3 listStyle="dot">대상</SubTitle3>
            <div class="grid-2">
                <NumberRow idx="01" content="국내 체류기간이 6개월 이하인 외국인 관광객" />
                <NumberRow idx="02" content="해외 2년 이상 체류하는 내국인 (영주권, 유학, 취업, 연수 등)" />
                <NumberRow idx="03" content="입국 후 체류기간 3개월 이내인 해외거주자 내국인" />
            </div>
        </SubSection>
        <SubSection type="wide">
            <SubTitle3 listStyle="dot">환급 절차</SubTitle3>
            <div class="grid-3">
                <CardBox3 idx="1" title="물품 구매" content="15,000원 이상 구매 후 매장 직원에게 <br />택스리펀드 전표를 요청합니다." />
                <CardBox3 idx="2" title="반출 확인"
                    content="출국 시 세관 직원에게 3개월 이내에 구매한 <br />물품, 택스리펀드 전표, 여권을 제시한 후 <br />반출 확인 스탬프를 받습니다. <br /><strong class='bold'>(반출 확인이 없는 경우 환급이 불가합니다.)</strong>" />
                <CardBox3 idx="3" title="환급 받기"
                    content="공항 및 항만 출국장 환급 창구에서 <br />현금으로 수령이 가능하며 메일박스 이용 시 <br />신용카드 및 알리페이 계좌로 환급금이 입금됩니다." />
            </div>
        </SubSection>
        <SubSection>
            <SubTitle3 listStyle="dot">환급 창구 위치</SubTitle3>
            <div class="map_container">
                <div class="left_area">
                    <img src="@/assets/sub3_map.png" alt="" />
                </div>
                <div class="right_area">
                    <RedLineButton type="outbound" text="환급 창구 위치 확인하기" @click="modalOpen(2)" />
                    <ul class="map_list">
                        <li>
                            <div class="img_area">
                                <img src="@/assets/sub3_marker_c.png" alt="" />
                            </div>
                            <div class="text_area">
                                <div class="title">환급창구</div>
                                <div class="content">출국 전 공항에서 현금으로 환급 받을 수 있습니다.</div>
                            </div>
                        </li>
                        <li>
                            <div class="img_area">
                                <img src="@/assets/sub3_marker_m.png" alt="" />
                            </div>
                            <div class="text_area">
                                <div class="title">메일박스</div>
                                <div class="content">출국 후 신용카드(VISA, MASTER, JCB) 또는 알리페이 계좌로 환급 받을 수 있습니다.</div>
                            </div>
                        </li>
                        <li>
                            <div class="img_area">
                                <img src="@/assets/sub3_marker_b.png" alt="" />
                            </div>
                            <div class="text_area">
                                <div class="title">시내환급</div>
                                <div class="content">출국 전 도시에서 현금으로 환급 받을 수 있습니다.</div>
                            </div>
                        </li>
                    </ul>
                    <p>
                        * 그 외 출국 경로를 이용하시거나 환급 전표를 제출하지 못하신 경우 <a href="mailto:etrs@kicc.co.kr">etrs@kicc.co.kr</a> 로
                        연락주시기 바랍니다.
                    </p>
                </div>
            </div>
        </SubSection>
        <SubSection type="wide" class="pb-160">
            <SubTitle3 listStyle="dot">서비스 신청 안내</SubTitle3>
            <div class="grid-3">
                <CardBox3 idx="1" title="사후 면세판매장 신청" content="
                사업장 소재 관할 세무서에서 외국인 관광객 <br />
                면세판매장 지정을 신청합니다.<br />
                (인터넷, 방문, 우편 가능)<br /><br />
                <span class='fz-14'>
                  ※ 보다 자세한 사항은 <a class='bold strike' target='_blank' href='https://www.law.go.kr/lsInfoP.do?lsId=004262&ancYnChk=0#0000' >외국인관광객 등에 대한 <br />부가가치세 및 개별소비세 특례규정</a>을 참고해주세요.
                </span>
                " />
                <CardBox3 idx="2" title="서비스 신청 및 상담"
                    content="관할 세무서에서 외국인 관광객 면세판매장 지정증 수령 후 <br />온라인 고객문의 또는 고객센터(<a href='tel:1600-1234'>1600-1234</a>)를 통해 <br />상담을 접수합니다.">
                    <OrangeLineButton text="서비스 신청" to="/cs/voc" />
                </CardBox3>
                <CardBox3 idx="3" title="서비스 오픈" content="가맹점 계약이 완료되면 택스리펀드 서비스를 <br />이용하실 수 있습니다.<br />단말기/프로그램 설치 등 서비스 운영에 <br />필요한 사항에 대한 지원이 가능합니다.
" />
            </div>
        </SubSection>
    </LayoutSub>

    <div class="modal_container foreigner" v-if="modalCheck" @click.stop>
        <!-- <div class="modal_wrapper modal-1" @click.stop="" v-show="modalNumber === 1">
            <div class="modal_header">
                <p>거래내역 조회</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="modal_box">
                    <div class="title_row">
                        <p class="title">여권번호</p>
                    </div>
                    <div class="input_group">
                        <div class="row">
                            <input type="text" />
                            <button type="submit">검색</button>
                        </div>
                        <p>* 입력하신 여권번호는 단순 조회용으로 사용되며 저장되지 않습니다</p>
                    </div>
                </div>
                <div class="modal_list">
                    <div class="modal_list_header">
                        <div class="modal_list_item">성명</div>
                        <div class="modal_list_item">국적</div>
                        <div class="modal_list_item">환급승인번호</div>
                        <div class="modal_list_item">거래일시</div>
                        <div class="modal_list_item">구매금액</div>
                        <div class="modal_list_item">환급금액</div>
                        <div class="modal_list_item">환급방법</div>
                        <div class="modal_list_item">환급접수일</div>
                    </div>
                    <div class="modal_list_body no-data">
                        <p>조회된 내역이 없습니다.</p>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="modal_wrapper modal-2" @click.stop="" v-show="modalNumber === 2">
            <div class="modal_header">
                <p>환급 창구 위치 확인하기</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="modal_tab_wrap">
                    <button :class="modalContentNum === 1 ? 'selected' : ''"
                        @click="modalContentChange(1)">김포공항</button>
                    <button :class="modalContentNum === 2 ? 'selected' : ''"
                        @click="modalContentChange(2)">김해공항</button>
                    <button :class="modalContentNum === 3 ? 'selected' : ''"
                        @click="modalContentChange(3)">인천공항</button>
                    <button :class="modalContentNum === 4 ? 'selected' : ''"
                        @click="modalContentChange(4)">제주공항</button>
                </div>
                <div class="modal_content" v-show="modalContentNum === 1">
                    <!-- <p class="content_header">김포공항</p> -->
                    <p class="content_body">
                        전표작성 → 세관확인 → 환급금수령<br />
                        填写退税发票 → 海关确认 → 领取退税金<br />
                        Fill out refund receipts → Get a customs stamps → Cash refund at counter
                    </p>
                    <img src="@/assets/vat_modal1.png" alt="" />
                </div>
                <div class="modal_content" v-show="modalContentNum === 2">
                    <!-- <p class="content_header">김해공항</p> -->
                    <p class="content_body">
                        환급전표에 개인정보(여권번호, 신용카드번호, 알리페이 핸드폰번호)를 적은 후, 세관직원에게 구매물품과 환급전표를 제시하여
                        확인도장을 받습니다. 6-9일 후 환급금이 계좌로 들어갑니다.<br />
                        请您在退税发票上填写个人信息（护照号码/信用卡号码/支付宝绑定的手机 号码）后，
                        向海关职员出示购买物品和退税发票，盖海关的确认章。6-9工作日后将退税金快速倒账。<br />
                        Fill out personal information (Passport, Credit card number), get customs stamped at the
                        airport. When dropping your receipts
                        in the mail box, tax refund will be deposited into your bank account in two weeks.<br />
                        還付伝票に個人情報（パスポート・クレジットカード番号）を記入して、税関で搬出確認を受けて
                        下さい。メールボックスに伝票を入れてから2週後、還付金が振り込まれます。
                    </p>
                    <img src="@/assets/vat_modal1.png" alt="" />
                </div>
                <div class="modal_content" v-show="modalContentNum === 3">
                    <!-- <p class="content_header">인천공항</p> -->
                    <p class="content_body">
                        B/D/J/L의 환급기계에 환급전표 입력 → 세관확인 → Gate27에서 현금수령<br />
                        在B/D/J/L的退税器上扫描退税发票 → 海关确认在 → Gate27领取退税金<br />
                        Scan receipts at B/D/J/L ATM → Get stamped → Cash refund at Gate27<br />
                        B/D/J/Lのキオスク端末で伝票入力 → 税関確認 → Gate27キオスク端末で還付
                    </p>
                    <img src="@/assets/vat_modal1.png" alt="" />
                </div>
                <div class="modal_content" v-show="modalContentNum === 4">
                    <!-- <p class="content_header">제주공항</p> -->
                    <p class="content_body">
                        전표작성 → 세관확인 → 환급금수령<br />
                        填写退税发票 → 海关确认 → 领取退税金<br />
                        Fill out refund receipts → Get a customs stamps → Cash refund at counter<br />
                        還付伝票作成 → 稅関搬出確認 → 窓口で現金還付<br />
                    </p>
                    <img src="@/assets/vat_modal1.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CardBox3 from '@/components/CardBox3.vue';
import LineBox from '@/components/LineBox.vue';
import NumberRow from '@/components/NumberRow.vue';
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        RedLineButton,
        TableRow_2grid,
        OrangeLineButton,
        CardBox3,
        LineBox,
        NumberRow,
    },
    data() {
        return {
            modalCheck: false,
            modalContentNum: 1,
            modalNumber: 0,
        };
    },
    methods: {
        modalOpen(idx) {
            this.modalCheck = !this.modalCheck;
            if (this.modalCheck) document.querySelector('html').style.overflow = 'hidden';
            else document.querySelector('html').removeAttribute('style');

            if (idx) {
                this.modalNumber = idx;
            }
        },
        modalContentChange(idx) {
            this.modalContentNum = idx;
        },
    },
    watch: {
        modalCheck: function () {
            if (this.modalCheck) this.$lenis.stop();
            else this.$lenis.start();
        },
    },
};
</script>